import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { SECTION_BLOG_PAGE, SECTION_BLOG_POST_PAGE, getPostPageEnabled } from '@wix/communities-blog-client-common';
import ExternalLink from '../../components/link/external-link';
import { createNavigation } from '../create-navigation';
import { getConfig } from '../config';

const ExternalBlogLink = flowRight(
  connect((state) => {
    const { sectionUrl: feedSectionUrl, postPageSectionUrl } = getConfig();
    const isPostPageEnabled = getPostPageEnabled(state) && (!feedSectionUrl || postPageSectionUrl);
    return {
      appDefinitionId: BLOG_APP_ID,
      sectionId: isPostPageEnabled ? SECTION_BLOG_POST_PAGE : SECTION_BLOG_PAGE,
      sectionUrl: isPostPageEnabled ? postPageSectionUrl : feedSectionUrl,
    };
  }),
)(ExternalLink);

const createWidgetNavigation = (store) => {
  const navigation = createNavigation(store);
  navigation.Link = ExternalBlogLink;
  return navigation;
};

export default createWidgetNavigation;
